// extracted by mini-css-extract-plugin
export default {"modalHeader":"d-ZLv","notIframe":"EaLwI"};